export const initialState = {
    id: '',
    email: '',
    balance: 0,
    purchasedGiftIds: null,
    isLoading: false,
    error: null,
};
